import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { BENEFITS_KEY, PricePlanService } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { FormValidation, SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { TEXT_FIELDS } from '../customer-service.service';
import { ManageTemplateComponent } from '../manage-template/manage-template.component';
import { PlanCardComponent } from '../plan-card/plan-card.component';

@Component({
  selector: 'app-contact-details',
  standalone: true,
  imports: [CommonModule, ManageTemplateComponent, PlanCardComponent],
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss' ,'../../../../../styles/admin/style.scss',
    "../../../../../styles/admin/app.scss"]
})
export class ContactDetailsComponent extends FormValidation {

  PLANMAX : number = 0;
  AVAILABLE : number = 0;
  ALLOCATED : number = 0;
  columns : Array<Partial<TEXT_FIELDS>>;
  businessNetworkDetails !: any;
  userDatas = new BehaviorSubject([]);
  businessData: any;
  prevSearchAfterKey : any;
  stopScroll : boolean = false;
  payload = {
    searchContent : null,
    page: 0,
    statusList : ['CONNECTED', 'INACTIVE'],
    searchAfterKey : null,
    businessId : null,
    limit : 10,
    organisationType: null,
    type: 'MANAGE',
    orgType:null,
  }
  allocationCards = [
    {
      name : "Plan Max",
      value : null
    },
    {
      name : "Allocated",
      value : null
    },
    {
      name : "Active",
      value : null
    },
  ];
  filterData = [
    {
      label: 'Contact Type',
      payload: 'organisationType',
      options: [
        { value: 'Supplier', label: 'Supplier' },
        { value: 'Client', label: 'Client' },
      ],
    },
    {
      label: 'Org Type',
      payload: 'orgType',
      options: [
       
        { value: 'Client', label: 'Client' },
        { value: 'Systems Integrator', label: 'Systems Integrator' },
        { value: 'Prime Vendor', label: 'Prime Vendor' },
        { value: 'Staffing Agency', label: 'Staffing Agency' }
      ],
    },
    {
      label: 'Status',
      payload: 'status',
      options: [
        { value: 'CONNECTED', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' },
      ],
    }
  ]

  constructor(private API: ApiService, private _activated_route: ActivatedRoute ,
    private pricePlanService: PricePlanService , private util : UtilService) {
    super();
     this.columns = [
      { label: "UID", key: "gigsumoNo" },
      { label: "Name", key: "fullName" },
      { label: "Email", key: "email" },
      { label: "Role", key: "role" },
      { label: "Contact Type", key: "contactType" },
      { label: "Organization", key: "organisation" },
      { label: "Org Type", key: "clientType" },
     ];

     this.businessNetworkDetails = {
       networkName : "Prasnana",
       owner : "pp@gmail.com",
       members : 10
     }



     this._activated_route.parent.data.subscribe(res => {
       this.businessData = res.data;
     });


   }

  ngOnInit(): void {
      this.payload.businessId = this.businessData.id;
      this.getContactsList();
  }

  getCustomerUsersList(userPayload: Object): Observable<any> {
    this.util.startLoader();
    return this.API.create('business/findUserContactsOfBusiness', userPayload);
  }

  convertToTitleCase(str) {
    if(str=== GigsumoConstants.MANAGEMENT_TALENT_ACQUISITION) {
      str = GigsumoConstants.MANAGER;
    }
    return str
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  activeContacts:number;
  getContactsList() {
    this.getCustomerUsersList(this.payload).subscribe(response=>{
      if(response) {
        this.util.stopLoader()
      }
      if (response.code === GigsumoConstants.SUCESSCODE) {

        if (this.payload.searchAfterKey==null && (response?.data?.activeContacts || response?.data?.activeContacts === 0)) {
          this.activeContacts = response?.data?.activeContacts;
        }
        const users = response.data.businessContactList;
        const searchKey = response.data.searchAfterKey;
        if (users) {
          users.forEach(x=>{
            x.userType = this.convertToTitleCase(x.userType);
          })
            users.forEach((user) => {
              const updatedUserType = this.convertToTitleCase(user.userType);
              user.role = updatedUserType;
            });
          const current = users;
          const exist = this.userDatas.getValue();
          this.userDatas.next([...exist , ...current]);
        }

        if(users != null && (users.length === 0 || users.length < 10 ||
          JSON.stringify(this.prevSearchAfterKey) === JSON.stringify(searchKey))){
          this.stopScroll = true;

        }
        this.prevSearchAfterKey =  searchKey;
        let plan = response.data.businessPlanUsage;
        let found =  (plan.benefitsUsages && plan.benefitsUsages.
          find(x => (x.benefitKey as BENEFITS_KEY) === 'INCLUDED_CONVERSATIONS'));
        if(found){
          this.PLANMAX = found.actual == 99999999 ? 'Unlimited' : found.actual;
          this.AVAILABLE = this.activeContacts;
          this.ALLOCATED = found.utilized;
          this.allocationCards[0].value = this.PLANMAX;
          this.allocationCards[1].value = this.ALLOCATED;
          this.allocationCards[2].value = this.AVAILABLE;
        }

      }
    });
  }

  updateBusinessNetwork(event) {
  }


  async updateContactMembers(members) {
    const userData = members.value;
    let data = {
      businessId : this.businessData.id,
      userId : userData.userId,
      status : userData.connectionStatus
    };
    const  updatedData =  JSON.parse(JSON.stringify(this.userDatas.getValue()));

    if(members.checked){
      this.util.startLoader();
      const plan = await this.getBusinessPLanBenefits();
      if(plan.available > 0){
         this.updateMembersBulk(data);
      }
      else{
        updatedData.forEach(res=>{
          if(res.userId === userData.userId){
            res.connectionStatus = "INACTIVE";
          }
        });
        this.userDatas.next(updatedData);
        this.pricePlanService.expiredPopup(
          "INCLUDED_CONVERSATIONS",
          "PAY",
          null,
          null,
          null,
          null,
          plan.available,
          plan.actual,
          plan.utilized,
          plan.promotional
        );
      }

      this.util.stopLoader();

    }
    else if(!members.checked){

      SWAL_WITH_BUTTONS.fire({
        icon: "warning",
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        title : "Inactive Contact",
        allowOutsideClick : false,
        text : `Are you sure you want to inactive ${userData.fullName} ?`
      }).then(res=>{

        if(res.isConfirmed){
          this.updateMembersBulk(data);
        }
        else{
          updatedData.forEach(res=>{
            if(res.userId === userData.userId){
              res.connectionStatus = "CONNECTED";
            }
          });
          this.userDatas.next(updatedData);
        }


      });
    }

  }


  updateMembersBulk(data){
     this.API.updatePut("business/updateBusinessUsersContacts" , [data]).subscribe(response=>{
        if(response.code === GigsumoConstants.SUCESSCODE){
             Swal.fire({
              icon : "success",
              title : "Contact updated successfully",
              showConfirmButton: false,
              timer: 2000,
            });

            setTimeout(() => {
                this.payload.searchAfterKey = null;
                this.prevSearchAfterKey = null;
                this.stopScroll = false;
                this.userDatas.next([]);
                this.getContactsList();
            }, 1000);
            this.util.stopLoader();

        }
    });
  }


  async getBusinessPLanBenefits() {
    this.util.startLoader();
    const userPlan: any = await this.API.lamdaFunctionsget('findBusinessPlanBenefits/' + this.businessData.id);
    const plan = userPlan.data.businessPlanAndBenefits.benefitsUsages;
    if (plan) {
      return plan.find(x => x.benefitKey === "INCLUDED_CONVERSATIONS");
    }
  }


  onSearch(value , obj : ContactDetailsComponent){
    obj.payload = {
      ...obj.payload,
      searchContent : value,
      searchAfterKey : null
    };
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    this.prevSearchAfterKey = null
    obj.getContactsList();
  }

  onFilter(data , obj : ContactDetailsComponent){
    obj.payload = {
      ...obj.payload,
      organisationType: data.organisationType != null ? data.organisationType : null,
      orgType: data.orgType != null ? data.orgType : null,
      statusList : data.status != null ? [data.status] :  data.status === null ? ["CONNECTED", "INACTIVE"] : null,
      searchAfterKey : null
    }
    obj.stopScroll = false;
    obj.prevSearchAfterKey = null;
    obj.userDatas.next([]);
    obj.getContactsList();
  }

  onScroll(obj : ContactDetailsComponent){
    if(!this.stopScroll){
      obj.payload = {
        ...obj.payload,
        searchAfterKey : obj.prevSearchAfterKey
      };
      obj.getContactsList();
    }
  }
}
